<template>
  <v-list-group>
    <template #activator>
      <v-list-tile>
        <v-list-tile-title>Notificari</v-list-tile-title>
      </v-list-tile>
    </template>
    <template #default>
      <v-progress-linear v-show="loading" indeterminate class="ma-0" style="position: absolute; top: -5px; left: 0" />
      <v-list-tile v-for="(title, topic) in allTopics" :key="topic">
        <v-list-tile-action>
          <v-checkbox v-model="selectedTopics" :value="topic" :disabled="loading" />
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ keywords[title] }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </template>
  </v-list-group>
</template>
<script>
import {mapActions, mapState} from 'vuex';
import keywords from '@/modules/home/lang/index.js';

export default {
  computed: {
    ...mapState('notifications', ['allTopics', 'topics', 'loading', 'error']),
    language () {
      return this.$store.state.lang.lang;
    },
    selectedTopics: {
      get() {
        return this.topics;
      },
      set(newTopics) {
        const added = newTopics.find(topic => !this.topics.includes(topic));
        if (added) {
          return this.subscribeTopic(added);
        }
        const removed = this.topics.find(topic => !newTopics.includes(topic));
        if (removed) {
          this.unsubscribeTopic(removed);
        }
      }
    },
    keywords() {
      return keywords[this.language];
    }
  },
  watch: {
    error (e) {
      e && console.log(e);
    }
  },
  methods: {
    ...mapActions('notifications', ['subscribeTopic', 'unsubscribeTopic'])
  }
};
</script>
